<template>
  
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: ""
    };
  }
};
</script>




// WEBPACK FOOTER //
// src/components/HelloWorld.vue